import { cx } from '@vizit/theme';

/**
 * Props for the dialog's scrollable middle region. Accepts standard `div` attributes;
 * `className` is optional and typically carries spacing (e.g. horizontal padding) —
 * the shrink/scroll styles are built in.
 */
interface DialogBodyProps extends React.HTMLAttributes<HTMLDivElement> {}

function DialogBody(props: DialogBodyProps) {
  const { className, ...other } = props;

  // min-h-0 lets this flex child shrink below its content height, so when the dialog
  // outgrows the viewport the body scrolls instead of pushing the footer past the
  // modal's overflow clip.
  return <div className={cx('min-h-0 overflow-y-auto', className)} {...other} />;
}

export { DialogBody };
